import _ from "lodash";

const sortArrayByAgeCategory = (array) => {
  const key = "ageCategory";
  const ageCategoryOrder = { X: 0, "X+": 1, Y: 2, "Y+": 3, Z: 4, "Z+": 5 };
  return _.sortBy(array, (item) => ageCategoryOrder[item[key]]);
};

export { sortArrayByAgeCategory };
